import { render, staticRenderFns } from "./Accountants.vue?vue&type=template&id=0640e1bb&scoped=true"
import script from "./Accountants.vue?vue&type=script&lang=js"
export * from "./Accountants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640e1bb",
  null
  
)

export default component.exports